import { useState } from "react"


export interface ITabs {
    value: string;
    handleChange: (event: any, newValue: string) => void;
    setValue: (newValue: string) => void;
}

export default function useTabs(defaultValue: string = ''): ITabs {
    const [value, setValue] = useState(defaultValue);

    const handleChange = (event: any, newValue: string) => {
        setValue(newValue);
    };

    return {
        value,
        handleChange,
        setValue
    };
}